module.exports = __webpack_public_path__ + "static/media/back-new-4.54a45c46.jpg";